export const usageIcon = `
<svg width="100%" height="100%" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="26" height="26"  />
<rect x="21" y="7" width="3" height="4" transform="rotate(90 21 7)" fill="currentColor"/>
<rect x="21" y="3" width="3" height="4" transform="rotate(90 21 3)" fill="currentColor"/>
<rect x="21" y="11" width="3" height="4" transform="rotate(90 21 11)" fill="currentColor"/>
<rect x="9" y="11" width="3" height="4" transform="rotate(90 9 11)" fill="currentColor"/>
<rect x="9" y="7" width="3" height="4" transform="rotate(90 9 7)" fill="currentColor"/>
<rect x="21" y="15" width="3" height="4" transform="rotate(90 21 15)" fill="currentColor"/>
<rect x="15" y="15" width="3" height="4" transform="rotate(90 15 15)" fill="currentColor"/>
<rect x="15" y="11" width="3" height="4" transform="rotate(90 15 11)" fill="currentColor"/>
<rect x="9" y="15" width="3" height="4" transform="rotate(90 9 15)" fill="currentColor"/>
<rect x="21" y="19" width="3" height="4" transform="rotate(90 21 19)" fill="currentColor"/>
<rect x="15" y="19" width="3" height="4" transform="rotate(90 15 19)" fill="currentColor"/>
<rect x="9" y="19" width="3" height="4" transform="rotate(90 9 19)" fill="currentColor"/>
</svg>
`;
